<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="EPI">Our knowledge isn’t much it’s just a small amount</p>
<p class="EPI">But you feel it quick inside you when you’re down for the count</p>
<p class="EPIS">—“The Songs We Know Best”</p>
<p class="EPI">Of course Eurydice vanished into the shade;</p>
<p class="EPI">She would have even if he hadn’t turned around.</p>
<p class="EPIS">—“Syringa”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?5f14c654